import React, { useMemo } from 'react';
import COLORS from '../styles/COLORS';

const CustomTooltip = (props) => {
  const data = useMemo(
    () => props?.api?.getDisplayedRowAtIndex(props?.rowIndex)?.data,
    []
  );

  let fieldValue = '';

  if (props.field === '8') {
    fieldValue = Array.isArray(data.tag) ? data.tag.join(', ') : data.tag;
  } else {
    switch (props.field) {
      case '1':
      case '3':
        fieldValue = props.data.project_name;
        break;
      case '2':
        fieldValue = props.data.project_number;
        break;
      case '5':
      case '7':
        fieldValue = props.data.package_name;
        break;
      case '6':
        fieldValue = props.data.package_number;
        break;
      case '9':
        fieldValue = props.data.meaning;
        break;
      default:
        fieldValue = '';
    }
  }

  return (
    props.isDisabled ? (
      <>
      </>
    ) : (
      <div
    className="custom-tooltip"
    style={{
      // backgroundColor: "#ececec",
      backgroundColor: COLORS.lightBlue,
      width: props.width,
      height: props.height,
    }}
  >
    <div className="panel-heading">
      {fieldValue && <span className="panel-title">{fieldValue}</span>}
    </div>
    <span className="panel-text" >{props.data?.in_progress ? "Please Wait, Tags are being processed" : props?.text}</span>
  </div>
    )
  );
};

export default CustomTooltip;
